<template>
  <div class="overdue-coupons">
    <div class="coupon-wrapper" v-show="overdueCoupons.length">
      <list :finished="finished" @load="onLoad" finished-text="没有更多了" v-model="loading">
        <coupon-list :list="overdueCoupons"></coupon-list>
      </list>
    </div>
    <no-data v-show="noData" />
  </div>
</template>

<script>
// 已过期卡券
import { List } from 'vant'
import CouponList from './CouponList'
import NoData from './NoData'
let flag = false
export default {
  name: 'overdue-coupons',
  components: {
    List,
    CouponList,
    NoData
  },
  data () {
    return {
      loading: false,
      finished: false,
      pageNum: 1,
      overdueCoupons: [],
      noData: false
    }
  },
  created () {
    this.$toast.loading('正在加载...')
    this.getOverdueCoupons()
  },
  methods: {

    onLoad () {
      if (flag) {
        return false
      }
      flag = true
      setTimeout(() => {
        this.getOverdueCoupons(++this.pageNum).then(() => {
          setTimeout(() => {
            flag = false
            this.loading = false
          }, 500)
        }, 300)
      })
    },

    /**
     * 获取过期卡券
     */
    async getOverdueCoupons (pageNum) {
      const res = await this.$axios.get(`api/coupon/expired/${pageNum || 1}`)
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg, data } = res.data
        if (code === 0) {
          const list = data.data.map(v => {
            v.couponStatus = 2
            return v
          })
          this.overdueCoupons = [...this.overdueCoupons, ...list]
        } else if (code === 9006) {
          this.finished = true
          if (pageNum === 1 || !pageNum) {
            this.noData = true
          }
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
</style>
